export const GET_DIVISIONS = "GET_DIVISIONS";
export const GET_DIVISION_BY_ID = "GET_DIVISION_BY_ID";
export const UPDATE_DIVISION = "UPDATE_DIVISION";
export const DELETE_DIVISION = "DELETE_DIVISION";
export const CREATE_DIVISION = "CREATE_DIVISION";
export const GET_PROGRAMS_BY_DIVISION = "GET_PROGRAMS_BY_DIVISION";
